// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"500b784b","552":"c4660cb4","580":"f488cbc2","796":"ac4c8911","808":"33736755","832":"ac90029e","912":"9d445a4f"}[chunkId] + ".chunk.js";
};